module.exports = __webpack_public_path__ + "img/set_radioChecked.c9c12e53.svg";